module.exports = __webpack_public_path__ + "img/jrwm.b8db9aa9.png";